import React from "react";
import { implementationSteps, implementationWeeks, parallelRuns } from "../../data/hrTechnology";
import { Exhibit } from "../Exhibit";
import { SectionLabel } from "../SectionLabel";
const ticks = [0, 4, 8, 12, 16, 20, 24];
const pct = (week: number) => `${week / implementationWeeks * 100}%`;
function tickAlign(t: number) {
  if (t === 0) return "";
  if (t === implementationWeeks) return "-translate-x-full";
  return "-translate-x-1/2";
}
function weekRange(start: number, end: number) {
  return start + 1 === end ? `Wk ${end}` : `Wk ${start + 1}–${end}`;
}
export function ImplementationTimeline() {
  return <section aria-labelledby="implementation-title" className="shell py-24 md:py-32" data-id="element-223" data-mp="3vam4e6eyqb2a">
      <div className="grid grid-cols-12 gap-x-6 gap-y-8 pb-14" data-id="element-224" data-mp="3rbdan1jxad6q">
        <div className="col-span-12 lg:col-span-3 lg:pt-3" data-id="element-225" data-mp="94fq2i1gf19m">
          <SectionLabel data-id="element-226" data-mp="94yxh4tha79e">Implementations</SectionLabel>
        </div>
        <div className="col-span-12 lg:col-span-9" data-id="element-227" data-mp="46nmurvczsq4">
          <h2 id="implementation-title" className="font-display text-[clamp(2.25rem,4.4vw,3.75rem)] leading-[1.05] text-navy" data-id="element-228" data-mp="43rq36v8za39">
            How we implement — and rescue — a system.
          </h2>
          <p className="mt-6 max-w-xl leading-relaxed text-charcoal/75" data-id="element-229" data-mp="1imdx1lchkj31">
            The same six phases whether we start on day one or take over halfway through. They overlap on purpose — and
            nothing goes live until two parallel payrolls tie out.
          </p>
        </div>
      </div>

      <Exhibit label="Exhibit — Implementation plan" title="A typical 24-week HRIS and payroll implementation" source="Representative plan for a multi-state employer moving HRIS and payroll together. P1 and P2 mark parallel payroll runs." data-id="element-230" data-mp="1wihml1cf0396">
        <div className="hidden grid-cols-12 gap-x-6 pb-3 md:grid" aria-hidden data-id="element-231" data-mp="2b8ox8uw6khzb">
          <div className="col-span-4" data-id="element-232" data-mp="2fbuxnlwm3exv" />
          <div className="relative col-span-8 h-4" data-id="element-233" data-mp="2f8qp6cc45x1e">
            {ticks.map(t => <span key={t} className={`absolute top-0 text-[11px] tabular-nums text-charcoal/60 ${tickAlign(t)}`} style={{
            left: pct(t)
          }} data-id="element-234" data-mp="2ka673vizvnfk">
                {t === 0 ? "Week 0" : t}
              </span>)}
          </div>
        </div>

        <ol className="border-t border-stone" data-id="element-235" data-mp="tzjj8z9xr4e5">
          {implementationSteps.map(s => {
          const isGoLive = s.name === "Go-live";
          const isTesting = s.name === "Testing & parallel";
          return <li key={s.name} className="grid grid-cols-12 items-center gap-x-6 gap-y-3 border-b border-stone py-5" data-id="element-236" data-mp="ywtdcs89s48b">
                <div className="col-span-12 md:col-span-4" data-id="element-237" data-mp="1cwkpenf87ajo">
                  <div className="flex items-baseline gap-3" data-id="element-238" data-mp="1ctyeqex1gex8">
                    <span className="w-5 font-display text-base tabular-nums text-oxblood" data-id="element-239" data-mp="17xracqkajbhe">{s.number}</span>
                    <h3 className="font-display text-xl text-navy" data-id="element-240" data-mp="3enxsd6xmv8d3">{s.name}</h3>
                    <span className="ml-auto whitespace-nowrap text-[11px] tabular-nums text-charcoal/60" data-id="element-241" data-mp="39pw8wkwap713">
                      {weekRange(s.start, s.end)}
                    </span>
                  </div>
                  <p className="mt-1.5 pl-8 text-sm leading-relaxed text-charcoal/70" data-id="element-242" data-mp="1u554dtbetvrv">{s.line}</p>
                </div>

                <div className="relative col-span-12 h-10 md:col-span-8" aria-hidden data-id="element-243" data-mp="1gc5qfvra09mf">
                  {ticks.map(t => <span key={t} className="absolute inset-y-0 w-px bg-stone" style={{
                left: pct(t)
              }} data-id="element-244" data-mp="16g2gi3q6n6ox" />)}
                  <span className={`absolute top-1/2 h-3 -translate-y-1/2 ${isGoLive ? "bg-oxblood" : "bg-navy"}`} style={{
                left: pct(s.start),
                width: pct(s.end - s.start)
              }} data-id="element-245" data-mp="1bff8t3ztp5yw" />
                  {isTesting && parallelRuns.map(p => <React.Fragment key={p.label} data-id="element-246" data-mp="2ruqa684n5ra3">
                        <span className="absolute top-1/2 h-3 w-0.5 -translate-x-1/2 -translate-y-1/2 bg-ivory" style={{
                  left: pct(p.week)
                }} data-id="element-247" data-mp="2vv0j9tnqcxt6" />
                        <span className="absolute top-0 -translate-x-1/2 text-[10px] font-semibold leading-none text-oxblood" style={{
                  left: pct(p.week)
                }} data-id="element-248" data-mp="225019obxcy01">
                          {p.label}
                        </span>
                      </React.Fragment>)}
                </div>
              </li>;
        })}
        </ol>
      </Exhibit>
    </section>;
}